module.exports = __webpack_public_path__ + "static/img/Xavier-Coates.a6c8ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Coates.jpg
// module id = uuJa
// module chunks = 0